
import React, { createContext, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import FetchUserDetails from '../Apis/FetchUserDetails';
import { showToast } from '../utils/toastUtils';
import configJson from "../Config.json"
const MyContext = createContext();


export const MyContextProvider = ({ children }) => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [autoCloseDrawer, setAutoCloseDrawer] = useState(false);
  const [getRecentHistory, setGetRecentHistory] = useState(false);
  const [jobDescriptionStatus, setJobDescriptionStatus] = useState({
    isEmailSent: false,
    isContinueChat: false,
  });
  const [checkUsageStatModalOpen, setCheckUsageStatModalOpen] = useState(false);
  const [usageModal, setUsageModal] = useState({
    isOpen: false,
    userId: null,
  });
  const [contactUsModalOpen, setContactUsModalOpen] = useState(false);
  const [upgradeModalOpen, setUpgradeModalOpen] = useState(false);
  const [isBackdropEnabled, setIsBackdropEnabled] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [limitExceededApiRunning, setLimitExceededApiRunning] = useState(false);
  const [chatLimitExceeded, setChatLimitExceeded] = useState(false);


  const checkAuthStatus = async () => {
    try {
      const token = localStorage.getItem('token');
      if (token) {
        if (verifyJWT(token)) {
          let accountDeactivated = false
          if (userDetails === null) {
            let userId = localStorage.getItem('userId')
            let response = await FetchUserDetails(userId)
            if (response.status === 200) {
              setUserDetails(response.data)

              let responseData_AccountConfig = response.data.accountConfig
              if (responseData_AccountConfig?.accountType?.typecode !== configJson.ACCOUNTTYPE_PERMANENT &&
                responseData_AccountConfig?.usedChatLimit >= responseData_AccountConfig?.chatLimit
              ) {
                setChatLimitExceeded(true)
              }
            }

            if (response.data.accountStatus.isPending === true && response.data.accountStatus.isRejected === true) {
              accountDeactivated = true
            }
          }
          if (accountDeactivated) {
            showToast("Your account has been deactivated. Contact support if you require further assistance", "error")
            localStorage.clear();
            return false;
          }
          else {
            return true;
          }
        }
        else {
          localStorage.clear();
          return false;
        }
      }
      else {
        return false;
      }
    } catch (error) {
      console.log('error', error)
      showToast('Something went wrong', 'error')
      return false
    }
  };

  const checkLimitExceed = () => {
    try {
      setLimitExceededApiRunning(true)
      let limitExceedStatus = false
      let userAccountConfig = userDetails?.accountConfig

      if (userAccountConfig) {
        let contractEndDate = new Date(userAccountConfig?.contractEndDate)
        let currentDate = new Date()
        if (userAccountConfig?.accountType?.typecode !== configJson.ACCOUNTTYPE_PERMANENT
          && currentDate > contractEndDate) {
          limitExceedStatus = true
        }
      }
      setLimitExceededApiRunning(false)
      return limitExceedStatus
    } catch (error) {
      console.log('error', error)
      setLimitExceededApiRunning(false)
      return false
    }
  }


  const verifyJWT = (token) => {
    try {
      const decoded = jwtDecode(token);

      const currentTime = Date.now() / 1000;
      if (decoded.exp && decoded.exp < currentTime) {
        return false;
      }

      return true;
    } catch (error) {
      console.error('Invalid token', error);
      return false;
    }
  };

  const handleNavigationAllow = () => {
    let isNavigationAllowed = true;
    let urlPath = window.location.pathname;
    if (urlPath.includes("/app/chat") && jobDescriptionStatus.isEmailSent === false) {
      const confirmNavigation = window.confirm("Are you sure you want to leave this chat? If you exit before generating the Job Description, the chat will not be saved.");
      if (!confirmNavigation) {
        isNavigationAllowed = false;
      }
      else {
        isNavigationAllowed = true;
        setJobDescriptionStatus({
          isEmailSent: false,
          isContinueChat: false
        })
      }
    }
    return isNavigationAllowed;
  }

  const resetJobDescriptionStatus = () => {
    setJobDescriptionStatus({
      isEmailSent: false,
      isContinueChat: false
    })
  }


  return (
    <MyContext.Provider
      value={{
        openDrawer, setOpenDrawer, autoCloseDrawer, setAutoCloseDrawer, checkAuthStatus, getRecentHistory,
        setGetRecentHistory, jobDescriptionStatus, setJobDescriptionStatus, checkUsageStatModalOpen, setCheckUsageStatModalOpen,
        checkLimitExceed, contactUsModalOpen, setContactUsModalOpen, upgradeModalOpen, setUpgradeModalOpen, handleNavigationAllow, resetJobDescriptionStatus,
        isBackdropEnabled, setIsBackdropEnabled, userDetails, setUserDetails, limitExceededApiRunning, setLimitExceededApiRunning,
        chatLimitExceeded, setChatLimitExceeded, usageModal, setUsageModal
      }}
    >
      {children}
    </MyContext.Provider>
  );
};

export default MyContext;
